<template>
  <div class="wrapper">
    <div class="logo">
      <img src="../../../assets/hw_logo2.png" style="vertical-align: middle;width:100px;height:100px" />
    </div>
    <div style="flex: auto;overflow: auto;" class="meun-user">
      <div class="menus">
        <Menu :theme="'dark'" width="160" size="small" :active-name="activeName" :open-names="openNames" ref="menu" @on-select="toItem">
          <template v-for="(item, index) in userMenus">
            <MenuItem v-if="!item.children" :name="item.name">
              <a :href="'#' + pathMap[item.name]">
                <img :src="icons[item.meta.icon + '']" alt="" class="icon" v-if="item.meta && item.meta.icon" />
                {{ item.title }}
              </a>
            </MenuItem>
            <Submenu v-else :name="item.name">
              <template slot="title">
                <img :src="icons[item.meta.icon + '']" alt="" class="icon" v-if="item.meta && item.meta.icon" />
                {{ item.title }}
              </template>
              <MenuItem v-for="(item1, index1) in item.children" :name="item1.name" :key="'menuitem' + index1">
                <a :href="'#' + pathMap[item1.name]">{{ item1.title }}</a>
              </MenuItem>
            </Submenu>
          </template>
        </Menu>
      </div>
      <div class="user">
        <div style="    display: flex;justify-content: space-between;">
          <span>{{ name }}</span>
          <span style="cursor: pointer" @click.stop="getOut">
            <img class="icon" style="position: relative;top: -1px;" src="../../../assets/icon_quit@2x.png" alt="" />
            退出</span
          >
        </div>
        <!--<div class="mt20 mb8">-->
        <!--<img class="icon" src="../../../assets/othericon/icon_download_16@2x.png" alt="">-->

        <!--下载超级zo</div>-->
        <!--<div class="zoimg">-->
        <!--<img src="../../../assets/zo.jpg" alt="">-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { menus } from '../../../router/index';

import operation from '../../../assets/newicon/icon_contract management_down@2x.png';
import dashboard from '../../../assets/newicon/icon_data_down@2x.png';
import ownership from '../../../assets/newicon/icon_expansion_down@2x.png';
import evaluationmanage from '../../../assets/newicon/icon_feedback_down@2x.png';
import financemanger from '../../../assets/newicon/icon_financial management_normal@2x.png';
import homepage from '../../../assets/newicon/icon_main page_down@2x.png';
import market from '../../../assets/newicon/icon_management center_down@2x.png';
import projectmanage from '../../../assets/newicon/icon_outlet_normal@2x.png';

import userinfo from '../../../assets/newicon/icon_personal information_down@2x.png';
import assetsmanage from '../../../assets/newicon/icon_todolist_down@2x.png';
import systemconfig from '../../../assets/newicon/icon_settings_down@2x.png';
import operaterule from '../../../assets/newicon/icon_xitongguanli_down@2x.png';
import workbench from '../../../assets/newicon/icon_todolist_down@2x.png';
import clockinmanage from '../../../assets/newicon/icon_data_down@2x.png';
// import {menuList} from "../../../api/systemmanage";
import { asyncRoutes } from '../../../router/index';

export default {
  name: 'Sidebar',
  data() {
    return {
      activeName: '',
      openNames: [],
      menus: menus,
      icons: {
        operation: operation,
        dashboard: dashboard,
        ownership: ownership,
        evaluationmanage: evaluationmanage,
        financemanger: financemanger,
        homepage: homepage,
        market: market,
        projectmanage: projectmanage,
        userinfo: userinfo,
        systemconfig: systemconfig,
        operaterule: operaterule,
        workbench: workbench,
        assetsmanage: assetsmanage,
        clockinmanage:clockinmanage,
      },
    };
  },
  watch: {
    $route(to, from) {
      this.updateActive();
    },
  },
  mounted() {
    this.updateActive();
    this.$store.dispatch('Userinfo').then((res) => {});
  },
  computed: {
    ...mapGetters(['name']),
    pathMap() {
      let ret = {};
      asyncRoutes[0].children.forEach((ele) => {
        ret[ele.name] = ele.path;
      });
      return ret;
    },

    userMenus() {
      if (!this.menuList) {
        return [];
      }

      function f(allmenus, apiList) {
        let ret = [];
        allmenus.forEach((ele) => {
          if (apiList.indexOf(ele.name) !== -1) {
            ret.push(ele);

            if (ele.children) {
              ele.children = f(ele.children, apiList);
            }
          }
        });
        return ret;
      }

      return f(this.menus, this.menuList);
    },
    ...mapGetters(['menuList']),
    menuMap() {
      if (!this.userMenus) {
        return null;
      }
      let ret = {};
      this.userMenus.forEach((ele) => {
        if (ele.children && ele.children.length) {
          ele.children.forEach((ele1) => {
            ret[ele1.name] = ele.name;
          });
        }
      });
      return ret;
    },
  },
  methods: {
    getOut() {
      this.$store
          .dispatch('Logout')
          .then((res) => {
            location.reload();
          })
          .catch((error) => {});
    },
    updateActive() {
      if (this.$route.meta.hidden) {
        return;
      }
      this.activeName = this.$route.name;
      if (this.menuMap && this.menuMap[this.activeName]) {
        this.openNames = [this.menuMap[this.activeName]];
      }
      this.$nextTick(() => {
        if (this.$refs['menu']) {
          this.$refs['menu'].updateOpened();
          this.$refs['menu'].updateActiveName();
        }
      });
    },
    toItem(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name: name });
      }
    },
  },
};
</script>

<style scoped>
.icon {
  /*width: 18px;*/
  /*!*line-height: 62px;*!*/
  /*vertical-align: middle;*/
  /*margin-right: 5px;*/
}
.zoimg {
  text-align: center;
}
.zoimg img {
  width: 100px;
}
.user {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  /*flex: none;*/
  height: 220px;
  color: rgba(255, 255, 255, 0.7);
  padding: 26px 24px;
  font-size: 14px;
}
.icon {
  width: 15px;
  vertical-align: middle;
}
.wrapper {
  height: 100%;
  width: 100%;
  background-color: #474e5d;
  display: flex;
  flex-direction: column;
}
.logo {
  text-align: center;
  flex: none;
  height: 170px;
  line-height: 170px;
}
.menus {
  /*flex: auto;*/
  /*overflow: auto;*/
  padding-bottom: 20px;
}
.meun-user::-webkit-scrollbar {
  width: 0 !important;
}
.white {
  color: rgba(255, 255, 255, 0.75);
}
.white:hover {
  color: rgba(255, 255, 255, 1);
}
a {
  color: rgba(255, 255, 255, 0.75);
}
a:hover {
  color: rgba(255, 255, 255, 1);
}
</style>
